import { render, staticRenderFns } from "./recorrente.vue?vue&type=template&id=1c36e8fc"
import script from "./recorrente.vue?vue&type=script&lang=js"
export * from "./recorrente.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports